import { LegalLinks } from '@/components/legal/LegalLinks';

/**
 * Global site footer (29 JUN 2026) · rendered by NavShell under every main app
 * screen (hidden on immersive screens: welcome / exams / tests / peek). Carries
 * the legal links + cookie settings so they are reachable from anywhere in the
 * signed-in app.
 */

/** Screens where the footer would intrude on an immersive flow. */
const HIDE_ON = new Set(['welcome', 'finaltest', 'mock', 'exam', 'peek']);

export function SiteFooter({ screen }: { screen?: string }) {
  if (screen && HIDE_ON.has(screen)) return null;
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__inner">
        <span className="site-footer__brand">© {year} QA Studio</span>
        <LegalLinks className="site-footer__links" />
      </div>
    </footer>
  );
}
